import { __extends } from "tslib";
import { CustomError } from "./../utils/error";
import { isPlainObject } from "./../utils/object";
import { htmlEscape, isString } from "./../utils/string";
import { isBoolean } from "./../utils/boolean";
import { Log } from "./../utils/Log";
import { ERR_INVALID_ARGUMENT, newError } from "../utils/error";
import { ajax } from "../utils/async";
import { isArray } from "../utils/array";
var SoapError = /** @class */ (function (_super) {
    __extends(SoapError, _super);
    function SoapError(pMessage, pDetail, pMethodName) {
        var _this = _super.call(this, pMessage) || this;
        Object.setPrototypeOf(_this, SoapError.prototype);
        _this.name = "SoapError";
        _this.mDetail = pDetail;
        _this.mMethodName = pMethodName;
        return _this;
    }
    Object.defineProperty(SoapError.prototype, "detail", {
        get: function () {
            return (this.mDetail);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SoapError.prototype, "methodName", {
        get: function () {
            return (this.mMethodName);
        },
        enumerable: false,
        configurable: true
    });
    return SoapError;
}(CustomError));
export { SoapError };
var SoapService = /** @class */ (function () {
    function SoapService(pUrl, pNamespaceUrl, pSessionId) {
        this.mUrl = pUrl;
        this.mNamespaceUrl = pNamespaceUrl;
        this.mSessionId = pSessionId;
    }
    Object.defineProperty(SoapService.prototype, "url", {
        get: function () {
            return (this.mUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SoapService.prototype, "namespaceUrl", {
        get: function () {
            return (this.mNamespaceUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SoapService.prototype, "sessionId", {
        get: function () {
            return (this.mSessionId);
        },
        enumerable: false,
        configurable: true
    });
    SoapService.SoapDataToArray = function (pSoapData, pItemCallback) {
        if (pSoapData == null)
            return (undefined);
        var tItems = new Array();
        if (Array.isArray(pSoapData)) {
            for (var i = 0; i < pSoapData.length; ++i) {
                var tItem = pItemCallback == null ? pSoapData[i] : pItemCallback(pSoapData[i]);
                tItems.push(tItem);
            }
        }
        else {
            var tItem = pItemCallback == null ? pSoapData : pItemCallback(pSoapData);
            tItems.push(tItem);
        }
        return (tItems);
    };
    //NU = Not Undefined
    SoapService.SoapDataToArrayNU = function (pSoapData, pItemCallback) {
        var tArray = SoapService.SoapDataToArray(pSoapData, pItemCallback);
        return (tArray == null ? [] : tArray);
    };
    SoapService.SoapDataToBool = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        return (pSoapData === "true");
    };
    SoapService.SoapDataToFloat = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        return (parseFloat(pSoapData));
    };
    SoapService.SoapDataToInt = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        return (parseInt(pSoapData));
    };
    SoapService.GetSoapDataNodeValue = function (pSoapData) {
        if (pSoapData == null)
            return (undefined);
        if (isString(pSoapData))
            return (pSoapData);
        else
            return (pSoapData[SoapService.NODE_TEXT_KEY]);
    };
    SoapService.SerializeDataToXml = function (pData) {
        if (isString(pData)) {
            return (pData); //xml string expected
        }
        else if (isPlainObject(pData)) {
            return (SoapService.ObjectToXml(pData, true));
        }
        else {
            return (null);
        }
    };
    SoapService.DeserializeXmlToObject = function (pXml) {
        if (pXml == null)
            return (null);
        //parse xml
        var tResponse;
        try {
            tResponse = (new DOMParser()).parseFromString(pXml, "text/xml");
        }
        catch (e) {
            tResponse = undefined;
        }
        if (tResponse == null || tResponse.documentElement == null || tResponse.getElementsByTagName("parsererror").length > 0) {
            throw newError(ERR_INVALID_ARGUMENT, "Invalid XML string");
        }
        return (SoapService.XmlToJson(tResponse));
    };
    SoapService.prototype.soapAjax = function (pMethod, pData, pOptions) {
        var _this = this;
        //build soap request header
        var tDataXml = SoapService.SerializeDataToXml(pData);
        var tSoapXML = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
            '<s:Body xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">' +
            ("<" + pMethod + " xmlns=\"" + this.mNamespaceUrl + "\" xmlns:ns1=\"" + this.mNamespaceUrl + "\">") +
            tDataXml +
            ("</" + pMethod + "></s:Body></s:Envelope>");
        var tOptions = {
            dataType: "xml",
            timeout: this.requestTimeout,
            headers: {
                "Content-Type": "text/xml; charset=UTF-8"
            }
        };
        Object.assign(tOptions, pOptions);
        var tPromise = ajax("POST", this.mUrl, tSoapXML, tOptions, function (pError, pXhr, pResponse) {
            var tResponseBody = _this.getErrorBodyFromXhr(pXhr, pResponse);
            if (tResponseBody != null) {
                var tError = tResponseBody["S:Fault"]["faultstring"];
                var tDetailSoap = tResponseBody["S:Fault"]["detail"];
                var tDetail = void 0;
                if (tDetailSoap != null) {
                    tDetail = _this.getErrorDetail(tDetailSoap);
                }
                if (SoapService.LogSoapErrors) {
                    Log.warn("EAIWS-Error: " + tError);
                }
                return (new SoapError(tError, tDetail, pMethod));
            }
            return (pError);
        }).then(function (pResponse) {
            var tResponseBody = _this.getBodyFromSoapResponse(pResponse);
            var tResponseData = null;
            if (tResponseBody != null)
                tResponseData = tResponseBody["ns2:" + pMethod + "Response"]["return"];
            return (tResponseData);
        });
        return (tPromise);
    };
    SoapService.prototype.getErrorDetail = function (pSoapData) {
        return (undefined);
    };
    SoapService.ObjectToXml = function (pObj, pAddXmlns) {
        var tXmlString = "";
        if (pObj instanceof SoapRequestData) {
            for (var tProperty in pObj) {
                if (pObj.hasOwnProperty(tProperty) && !pObj._isAttribute(tProperty) && tProperty !== "_ensureTypeSafety") {
                    tXmlString += SoapService.PropertyToXml(tProperty, pObj._getPropertyValue(tProperty), pAddXmlns);
                }
            }
        }
        else {
            for (var tProperty in pObj) {
                if (pObj.hasOwnProperty(tProperty)) {
                    tXmlString += SoapService.PropertyToXml(tProperty, pObj[tProperty], pAddXmlns);
                }
            }
        }
        return (tXmlString);
    };
    SoapService.PropertyToXml = function (pName, pValue, pAddXmlns) {
        if (pValue == null)
            return ("");
        var tXmlString = "";
        //array
        if (isArray(pValue)) {
            for (var i = 0; i < pValue.length; ++i) {
                tXmlString += SoapService.PropertyToXml(pName, pValue[i], pAddXmlns);
            }
            return (tXmlString);
        }
        if (pAddXmlns)
            tXmlString += "<" + pName + " xmlns=\"\"";
        else
            tXmlString += "<" + pName;
        var tRawValue = pValue;
        //special handling for attribute and node value properties
        if (pValue instanceof SoapRequestData) {
            //add xsi:type
            var tClassName = pValue._getClassName();
            if (tClassName != null) {
                tXmlString += ' xsi:type="ns1:' + tClassName + '"';
            }
            for (var tProperty in pValue) {
                if (!pValue.hasOwnProperty(tProperty))
                    continue;
                if (pValue._isAttribute(tProperty)) {
                    var tPropValue = pValue[tProperty];
                    if (tPropValue != null) {
                        tXmlString += " " + tProperty + "=\"" + htmlEscape(tPropValue.toString()) + "\"";
                    }
                }
                else if (pValue._isNodeText(tProperty)) {
                    //use node text as value, in this case all other properties except attributes will be ignored
                    tRawValue = pValue[tProperty];
                }
            }
        }
        tXmlString += ">";
        if (tRawValue != null) { //maybe undefined if it is a node text
            //plain object or SoapRequestData
            if (isPlainObject(tRawValue) || tRawValue instanceof SoapRequestData) {
                tXmlString += SoapService.ObjectToXml(tRawValue, false);
            }
            //boolean
            else if (isBoolean(tRawValue)) {
                tXmlString += tRawValue ? "true" : "false";
            }
            //string, number ...
            else {
                tXmlString += htmlEscape(tRawValue.toString());
            }
        }
        tXmlString += "</" + pName + ">";
        return (tXmlString);
    };
    SoapService.XmlToJson = function (pXml) {
        //this function was copied and modified from: https://github.com/sparkbuzz/jQuery-xml2json
        if (pXml == null)
            return (null);
        var tResult = {};
        var i, tNode, tChild, tName;
        //read attributes
        if (pXml instanceof Element && pXml.attributes.length > 0) {
            for (i = 0; i < pXml.attributes.length; i++) {
                var tItem = pXml.attributes.item(i);
                if (tItem == null)
                    continue;
                //handle special null attribute
                if (tItem.nodeName === "xsi:nil" && tItem.value === "true")
                    return (null);
                tResult[tItem.nodeName] = tItem.value;
            }
        }
        //process child nodes
        for (i = 0; i < pXml.childNodes.length; i++) {
            tNode = pXml.childNodes[i];
            switch (tNode.nodeType) {
                case 1: //1 = Element
                    var tElement = tNode;
                    if (tElement.attributes.length === 0 && tElement.childElementCount === 0) {
                        tChild = tNode.textContent; //normalize(tNode.textContent, options);
                    }
                    else {
                        tChild = SoapService.XmlToJson(tNode);
                    }
                    tName = tNode.nodeName;
                    if (tResult.hasOwnProperty(tName)) {
                        // For repeating elements, cast/promote the node to array
                        var tVal = tResult[tName];
                        if (!Array.isArray(tVal)) {
                            tVal = [tVal];
                            tResult[tName] = tVal;
                        }
                        tVal.push(tChild);
                    }
                    else {
                        tResult[tName] = tChild;
                    }
                    break;
                case 3: //3 = text node
                    tResult[SoapService.NODE_TEXT_KEY] = tNode.nodeValue;
                    break;
            }
        }
        return tResult;
    };
    SoapService.prototype.getBodyFromSoapResponse = function (pResponse) {
        if (pResponse == null || !(pResponse instanceof Node))
            return (null);
        var tJson = SoapService.XmlToJson(pResponse);
        if (tJson == null)
            return (null);
        return (tJson["S:Envelope"]["S:Body"]);
    };
    SoapService.prototype.getErrorBodyFromXhr = function (pXhr, pResponse) {
        var tXmlResponse = null;
        if (pResponse != null && pResponse instanceof Node)
            tXmlResponse = pResponse;
        else
            tXmlResponse = pXhr.responseXML;
        return (this.getBodyFromSoapResponse(tXmlResponse));
    };
    SoapService.LogSoapErrors = false;
    //// private ///////////////////////////////////////////////////////////////////////////////
    SoapService.NODE_TEXT_KEY = "soapNodeText";
    return SoapService;
}());
export { SoapService };
var SoapRequestData = /** @class */ (function () {
    function SoapRequestData() {
        //// protected /////////////////////////////////////////////////////////////////////////////////
        /**
         * Helper property to force correct type in TypeScript.
         * If you get a TypeScript error like `Property _ensureTypeSafety is missing` you are perhaps
         * using a plain JavaScript object as a parameter for a SOAP function call.
         * Please use the correct class instance instead.
         */
        this._ensureTypeSafety = "ensureTypeSafety";
    }
    /** @internal */
    SoapRequestData.prototype._isAttribute = function (pProperty) {
        var tAnyThis = this;
        if (tAnyThis._soapAttributes == null)
            return (false);
        return (tAnyThis._soapAttributes.has(pProperty));
    };
    /** @internal */
    SoapRequestData.prototype._isNodeText = function (pProperty) {
        return (this._soapNodetext === pProperty);
    };
    /** @internal */
    SoapRequestData.prototype._getPropertyValue = function (pProperty) {
        return (this[pProperty]);
    };
    /** @internal */
    SoapRequestData.prototype._getClassName = function () {
        return (undefined);
    };
    return SoapRequestData;
}());
export { SoapRequestData };
/**
 * Soap attribute decorator
 * Decorated properties will be used as soap attributes instead of elements.
 */
export function soapAttribute() {
    return function (pTarget, pPropertyKey) {
        if (pTarget._soapAttributes == null)
            pTarget._soapAttributes = new Set();
        pTarget._soapAttributes.add(pPropertyKey);
    };
}
/**
 * Soap node text decorator
 * The decorated property will be used as the element text. All other
 * properties (except attributes) will be ignored in this case.
 */
export function soapNodeText() {
    return function (pTarget, pPropertyKey) {
        pTarget._soapNodetext = pPropertyKey;
    };
}
var BaseEaiwsService = /** @class */ (function (_super) {
    __extends(BaseEaiwsService, _super);
    function BaseEaiwsService(pOwner, pUrl, pNamespaceUrl, pSessionId) {
        var _this = _super.call(this, pUrl, pNamespaceUrl, pSessionId) || this;
        _this.mOwner = pOwner;
        return _this;
    }
    return BaseEaiwsService;
}(SoapService));
export { BaseEaiwsService };
